import React from 'react';
import { Route } from 'react-router';
import SwitchConnected from './pages/components/utilities/router/SwitchConnected';
import ScrollToTop from './pages/components/utilities/router/ScrollToTop';
import WorkspaceEvent from './pages/WorkspaceEvent';
import PageEventNotFound from './pages/PageEventNotFound';
var Routes = function () { return (React.createElement(React.Fragment, null,
    React.createElement(ScrollToTop, null),
    React.createElement(SwitchConnected, null,
        React.createElement(Route, { path: '/', component: WorkspaceEvent }),
        React.createElement(Route, { component: PageEventNotFound })))); };
export default Routes;



//////////////////
// WEBPACK FOOTER
// ./src/routes.tsx
// module id = 480
// module chunks = 0